<template>
  <section class="admin-content">
    <Navbar />
    <main class="admin-main">

      <!-- ── Page Header ─────────────────────────────────────── -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center text-white" style="padding: 32px 0; gap: 16px;">
            <div class="header-icon-wrap">
              <i class="fe fe-send" style="font-size: 22px;"></i>
            </div>
            <div>
              <h4 class="mb-0 font-weight-bold">Request Treatment (Out-of-State)</h4>
              <small style="opacity: .8;">Submit a corridor access request for an enrollee</small>
            </div>
          </div>
        </div>
      </div>

      <div class="container mt-n3 pb-5">

        <!-- ── Search Card ─────────────────────────────────────── -->
        <div class="card shadow form-card mb-4">
          <div class="form-card-header">
            <div class="section-number">1</div>
            <h6 class="mb-0 font-weight-bold text-white">Find Enrollee</h6>
          </div>
          <div class="card-body px-4 pt-4 pb-3">
            <div class="form-group">
              <label class="small font-weight-bold text-secondary">Search by Insurance ID</label>
              <input type="text" class="form-control" placeholder="Enter Insurance ID" v-model="searchkey"
                @change="searchIDCard" />
            </div>
            <div class="d-flex" style="gap: 8px;">
              <button class="btn btn-submit px-4" @click="searchIDCard">
                <i class="fe fe-search mr-1"></i> Search
              </button>
              <button class="btn btn-outline-secondary px-4" @click="userDetails = true">
                <i class="fe fe-edit mr-1"></i> Enter Manually
              </button>
            </div>
          </div>
        </div>

        <!-- ── Enrollee Details Form ──────────────────────────── -->
        <div class="card shadow form-card" v-show="userDetails">
          <div class="form-card-header">
            <div class="section-number">2</div>
            <h6 class="mb-0 font-weight-bold text-white">Enrollee &amp; Destination Details</h6>
          </div>
          <div class="card-body px-4 pt-4 pb-3">
            <form @submit.prevent="AddDisease">

              <div class="text-center mb-4">
                <img :src="`${selected_enrollee.image_url}`" class="profile-photo" alt="User Photo"
                  onerror="this.onerror=null; this.src='/assets/img/ohis_logo.png'" />
              </div>

              <div class="form-row">
                <div class="form-group col-md-6">
                  <label class="small font-weight-bold text-secondary">Insurance ID</label>
                  <input type="text" class="form-control" v-model="selected_enrollee.id_card_number" />
                </div>
                <div class="form-group col-md-6">
                  <label class="small font-weight-bold text-secondary">First Name</label>
                  <input type="text" class="form-control" v-model="selected_enrollee.firstname" />
                </div>
                <div class="form-group col-md-6">
                  <label class="small font-weight-bold text-secondary">Last Name</label>
                  <input type="text" class="form-control" v-model="selected_enrollee.lastname" />
                </div>
                <div class="form-group col-md-6">
                  <label class="small font-weight-bold text-secondary">Phone Number</label>
                  <input v-phone type="text" class="form-control" v-model="selected_enrollee.phone_number" />
                </div>
                <div class="form-group col-md-6">
                  <label class="small font-weight-bold text-secondary">
                    Select State <span class="text-danger">*</span>
                  </label>
                  <select class="form-control" required v-model="transfer.state" @change="fetchLga">
                    <option :value="state" v-for="state in states" :key="state.id">
                      {{ state.agency_name }}
                    </option>
                  </select>
                </div>
                <div class="form-group col-md-6">
                  <label class="small font-weight-bold text-secondary">LGA</label>
                  <select class="form-control" v-model="transfer.localgovt" @change="getProvidersByLGAs">
                    <option v-for="lga in lga_states" v-bind:key="lga" :value="lga.id">
                      {{ lga.local_name }}
                    </option>
                  </select>
                </div>
                <div class="form-group col-md-12">
                  <label class="small font-weight-bold text-secondary">
                    Facility Enrollee wants to Access Care
                    <button type="button" class="btn btn-sm btn-outline-secondary ml-2" @click="getProviders">
                      Show All
                    </button>
                  </label>
                  <v-select v-model="referred_to_facility" label="agency_name" :options="providers" />
                </div>
                <div class="form-group col-md-12">
                  <label class="small font-weight-bold text-secondary">
                    Short description of how the enrollee is feeling currently
                  </label>
                  <textarea rows="3" class="form-control" v-model="comments[0].body" required></textarea>
                </div>
              </div>

              <div class="d-flex justify-content-end" style="gap: 10px;">
                <button type="button" class="btn btn-outline-secondary px-4" @click="userDetails = false">
                  Cancel
                </button>
                <button type="submit" class="btn btn-submit px-5">
                  <i class="fe fe-send mr-2"></i> Submit Request
                </button>
              </div>
            </form>
          </div>
        </div>

      </div>

      <div class="vld-parent">
        <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
      </div>
    </main>
  </section>
</template>

<script>
  import Navbar from "@/views/Navbar.vue";

  // Import component
  import Loading from "vue-loading-overlay";
  // Import stylesheet
  import "vue-loading-overlay/dist/vue-loading.css";

  export default {
    components: {
      Navbar,
      Loading,
    },
    data() {
      return {
        user: null,
        isLoading: false,
        fullPage: true,
        userDetails: false,
        selected_enrollee: {
          firstname: "",
          lastname: "",
          phone_number: "",
          id_card_number: "",
        },
        searchkey: "",
        lga_states: "",
        providers: "",
        referred_to_facility: "",
        comments: [
          {
            body: "I want to access treatment",
          },
        ],
        states: [],
        transfer: {
          my_state: "",
          state: "",
          localgovt: "",
          reason_for_change: "",
          client_id: "",
        },
      };
    },
    beforeMount() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/agencies`)
        .then((response) => {
          this.states = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    computed: {
      //
    },
    methods: {
      clearIt() {
        this.transfer.reason_for_change = "";
        this.transfer.new_health_facility = "";
        this.transfer.previous_health_facility = "";
        this.transfer.status = "";
        this.transfer.prepared_by = "";
        this.searchkey = "";
        this.enrollee_details = "";
      },

      searchIDCard() {
        this.isLoading = true;
        this.axios
          .post(`/api/v1/auth/searchenrollees`, {
            agency_id: 407465,
            request_query: this.searchkey,
          })
          .then((response) => {
            this.selected_enrollee = response.data[0];
            this.userDetails = true;

            this.isLoading = false;
          })
          .catch((error) => {
            this.loading = false;

            console.error(error);
            this.isLoading = false;
            this.$toasted.info("User not Found", {
              position: "top-center",
              duration: 3000,
            });
          });
      },
      fetchLga() {
        this.isLoading = true;
        this.getProviders();
        this.axios
          .get(`/api/v1/auth/lga/${this.transfer.state.state}`)
          .then((response) => {
            this.lga_states = response.data.data;
            this.isLoading = false;
          })
          .catch((error) => {
            console.error(error);
            this.isLoading = false;
          });
      },

      getProvidersByLGAs() {
        this.isLoading = true;

        this.axios
          .get(
            `/api/v1/auth/providerAgencies/${this.transfer.state.id}/${this.transfer.localgovt}`
          )
          .then((response) => {
            this.providers = response.data.data;
            this.isLoading = false;
          })
          .catch((error) => {
            console.error(error);
            this.isLoading = false;
          });
      },

      getProviders() {
        this.axios
          .get(`/api/v1/auth/providerAgency/${this.transfer.state.id}`)
          .then((response) => {
            this.providers = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      AddDisease() {
        this.isLoading = true;
        this.axios
          .post("/api/v1/auth/portability", {
            agency_id: 407465,
            secondary_agency_id: this.transfer.state.id,
            firstname: this.selected_enrollee.firstname,
            lastname: this.selected_enrollee.lastname,
            id_card_number: this.selected_enrollee.id_card_number,
            phone_number: this.selected_enrollee.phone_number,
            is_corridor: true,
            service_summary_id: 0,
            referred_to_facility: this.referred_to_facility.id,
            comments: this.comments,
          })
          .then((response) => {
            console.log(response);
            this.isLoading = false;
            this.$toasted.info("Successful!", {
              position: "top-center",
              duration: 3000,
            });
            this.$router.push(`/all-corridors`);
          })
          .catch((error) => {
            console.log(error.response);
            this.isLoading = false;
            this.$toasted.error("Not Added!", {
              position: "top-center",
              duration: 3000,
            });
          });
      },
    },
    created() {
      // this.getProviders();
    },
  };
</script>
